import { LearnositySubmitSettings } from '../models/LearnositySubmitSettings';
import { ItemsAppInterface } from '../vite-env';

export function submitAssessmentAsync(
  itemsApp: ItemsAppInterface,
  settings: LearnositySubmitSettings,
): Promise<string[]> {
  return new Promise(resolve => {
    itemsApp.submit({
      ...settings,
      success: resolve,
    });
  });
}
